import { useCampaign } from '@tm/client-form/src/hooks/useCampaign'
import { useRedirectSource } from '@tm/client-form/src/hooks/useRedirectSource'
import { useReplaceSegmentParameters } from '@tm/client-form/src/hooks/useReplaceSegmentParameters'
import { useSurveyProps } from '@tm/client-form/src/hooks/useSurveyProps'
import { ThirdPartyCollectSource } from '@tm/types/survey/third-party-collect'
import { useEffect, useState } from 'react'

const redirectDelaySeconds = 5

export const usePlatformRedirect = (sources?: ThirdPartyCollectSource[] | null, noRedirect?: boolean) => {
  const { campaignFrame } = useCampaign()
  /** -1 = countdown not yet started */
  const [redirectCountdownSeconds, setRedirectCountdownSeconds] = useState(-1)
  const redirectSource = useRedirectSource({ sources: sources || undefined })
  const { mainSegmentIds } = useSurveyProps()
  const finalRedirectSource =
    // Allow redirect if segment is set or there is only one source
    ((mainSegmentIds?.length || sources?.length === 1) &&
      // .. and it is not Trustmary
      redirectSource?.source !== 'Trustmary' &&
      redirectSource) ||
    null

  const redirectUrl = useReplaceSegmentParameters(finalRedirectSource?.url || '')

  useEffect(() => {
    if (!redirectUrl || noRedirect) {
      return
    }

    if (redirectCountdownSeconds >= 0) return

    setTimeout(() => {
      if (campaignFrame.inFrame) {
        window.open(redirectUrl, '_blank')
        return
      }

      window.location.href = redirectUrl
    }, redirectDelaySeconds * 1000)

    setRedirectCountdownSeconds(redirectDelaySeconds)

    setInterval(() => {
      setRedirectCountdownSeconds(seconds => Math.max(0, seconds - 1))
    }, 1000)
  }, [redirectUrl, noRedirect, campaignFrame, redirectCountdownSeconds])

  return {
    isRedirecting: !!redirectUrl && !noRedirect,
    redirectUrl,
    redirectCountdownSeconds,
    redirectSource: finalRedirectSource,
  }
}
